import route from "./route";
// import components from '@/demo/locale/en_US/components';

export default {
  route,
  "about": {
    "review": "Vui lòng xem trước bài viết trước khi đăng",
    "buttonPublic": "Đăng bài",
    "buttonReview": "Xem trước",
    "buttonCancel": "Hủy chỉnh sửa",
    "language": "Language",
    "createdBy": "Tạo bởi",
    "createdAt": "Tạo lúc",
    "lastEditedBy": "Chỉnh sửa lần cuối bởi",
    "lastEditedAt": "Chỉnh sửa lần cuối lúc"
  },
  "button": {
    "save": "LƯU",
    "import": "NHẬP THAM SỐ",
    "edit": "Sửa",
    "enable": "Kích hoạt",
    "disable": "Ngưng kích hoạt",
    "remove": "Bỏ ra",
    "cancel": "HỦY",
    "reload": "Tải lại",
    "close": "Đóng lại",
    "change": "THAY ĐỔi",
    "confirm": "XÁC NHẬN",
    "copy": "SAO CHÉP",
    "search": "TÌM KIẾM",
    "approve": "CHẤP NHẬN",
    "invite": "MỜI",
    "inviteUser": "Mời người dùng",
    "approveUser": "Chấp nhận",
    "rejectUser": "Từ chối",
    "editUser": "Sửa",
    "enableUser": "Kích hoạt",
    "diableUser": "Ngưng kích hoạt",
    "removeUser": "Xóa",
    "resendInvitation": "Gửi lại lời mời",
    "addProduct": "THÊM SẢN PHẨM",
    "addInsect": "THÊM CÔN TRÙNG",
    "addPackage": "THÊM LOẠI ĐÓNG GÓI",
    "addTechnique": "THÊM KỸ THUẬT",
    "addSetpointParameters": "THÊM THAM SỐ MỤC TIÊU",
    "addLocation": "Thêm chi nhánh",
    "addLocationUpercase": "THÊM CHI NHÁNH",
    "update": "CẬP NHẬT",
    "addCustomer": "THÊM KHÁCH HÀNG",
    "editCustomer": "CHỈNH SỬA KHÁCH HÀNG",
    "saveChangesCustomer": "LƯU THAY ĐỔI",
    "addTreatment": "THÊM DỮ LIỆU KHỬ TRÙNG",
    "editTreatment": "LƯU THAY ĐỔI",
    "addSetpoint": "THÊM THAM SỐ MỤC TIÊU",
    "updateProduct": "CẬP NHẬT SẢN PHẨM",
    "updateInsect": "CẬP NHẬT CÔN TRÙNG",
    "updatePackage": "CẬP NHẬT LOẠI ĐÓNG GÓI",
    "updateTechnique": "CẬP NHẬT KỸ THUẬT",
    "updateSetpoint": "CẬP NHẬT THAM SỐ MỤC TIÊU",
    "addTreatmentRequest": "Thêm yêu cầu khử trùng",
    "editTreatmentRequest": "LƯU THAY ĐỔI",
    "viewAll": "Xem tất cả",
    "addUnit": "THÊM PHÒNG",
    "addController": "THÊM BỘ DIỀU KHIỂN",
    "saveChangesControllervariable": "LƯU THAY ĐỔI",
    "export": "XUẤT THAM SỐ",
    "addInstruction": "THÊM HƯỚNG DẪN",
    "review": "XEM TRƯỚC",
    "publicInstruction": "ĐĂNG BÀI",
    "endReview": "KẾT THÚC XEM TRƯỚC",
    "editInstruction": "CHỈNH SỬA",
    "deleteInstruction": "XÓA",
    "cancelEdit": "THOÁT CHỈNH SỬA",
    "editLocation": "CHỈNH SỬA CHI NHÁNH",
    "editUnit": "CHỈNH SỬA PHÒNG",
    "addMail": "THÊM EMAIL",
    "editMail": "CHỈNH SỬA EMAIL",
    "editController": "CHỈNH SỬA BỘ DIỀU KHIỂN",
    "addEquipment": "THÊM THIẾT BỊ",
    "addMaintenanceJob": "THÊM VIỆC BẢO TRÌ",
    "publicAbout": "ĐĂNG BÀI",
    "editAbout": "CHỈNH SỬA THÔNG TIN",
    "editEquipment": "CHỈNH SỬA THIẾT BỊ",
    "saveChanges": "LƯU THAY ĐỔI",
    "viewList": "Xem danh sách",
    "continue": "TIẾP TỤC",
    "addFailure": "THÊM SỰ CỐ",
    "editFailure": "CHỈNH SỬA SỰ CỐ",
    "exportExcel": "XUẤT EXCEL",
    "addLicense": "Thêm giấy phép",
    "reject": "Từ chối",
    "previewShipment": "Xem trước chứng thư",
    "addRequest": "Thêm yêu cầu",
    "editRequest": "Sửa yêu cầu",
    "activate": "Kích hoạt",
    "changeTemplate": "Thay đổi mẫu",
    "addRule": "Thêm quy tắc",
    "select": "CHỌN",
    "addRpa": "Thêm RPA",
    "editRpa": "Chỉnh sửa RPA",
    "closeFailure": "ĐÓNG SỰ CỐ",
    "addUser": "THÊM NGƯỜI DÙNG",
    "allLocations": "Tất cả chi nhánh",
    "specificLocations": "Chi nhánh cụ thể",
    "add": "THÊM",
    "ACCEPT": "CHẤP NHẬN",
    "NEED_SUPPORT": "CẦN HỖ TRỢ",
    "REJECT": "TỪ CHỐI",
    "clearFilter": "XÓA BỘ LỌC",
    "filter": "BỘ LỌC",
  },
  "customer": {
    "view": "Xem",
    "edit": "Chỉnh sửa",
    "disable": "Ngưng kích hoạt",
    "enable": "Kích hoạt",
    "new": "Khách hàng mới"
  },
  "dialog": {
    "removeUser": {
      "title": "Chỉnh sửa người dùng",
      "content": "Bạn có chắc muốn bỏ thành viên <strong><%= user %></strong> ra khỏi nhóm?"
    },
    "userEdit": {
      "title": "Chỉnh sửa người dùng"
    },
    "addUser": {
      "title": "Thêm người dùng",
    },
    "approve": {
      "title": "Chấp nhận người dùng",
      "content": "Xin phân tổ chức cho người dung này",
      "shipmentCertificate": "Bạn có chắc muốn phê duyệt chứng thư đi hàng <strong>#<%= number %></strong> này không?",
    },
    "invite": {
      "title": "Mời người dùng",
      "content": "Để mời người dùng, vui lòng nhập email của người dùng. Hệ thống sẽ tự động gửi email cho người dùng này để hoàn tất đăng ký."
    },
    "reject": {
      "content": "Bạn có chắc muốn từ chối người dùng <strong><%= user %></strong> này truy cập hệ thống?",
      "shipmentCertificate": "Bạn có chắc muốn từ chối chứng thư đi hàng <strong>#<%= number %></strong> này không?"
    },
    "disable": {
      "content": "Bạn có chắc muốn vô hiệu hóa người dùng <strong><%= user %></strong>?"
    },
    "enable": {
      "content": "Bạn có chắc muốn kích hoạt người dùng <strong><%= user %></strong>?"
    },
    "resetPassword": {
      "content": "Bạn có chắc chắn muốn đặt lại mật khẩu cho người dùng <strong><%= user %></strong> không?"
    },
    "delete": {
      "content": "Bạn có chắc muốn xóa người dùng <strong><%= user %></strong>?",
      "treatment": "Bạn có chắc muốn xóa dữ liệu khử trùng?",
      "treatmentRequest": "Bạn có chắc muốn xóa yêu cầu khử trùng?",
      "failureTracking": "Bạn có chắc muốn xóa sự cố?",
      "shipmentCertificate": "Bạn có chắc muốn xóa chứng thư?",
      "license": "Bạn có chắc muốn xóa giấy phép?",
      "rpa": "Bạn có chắc muốn xóa RPA?",
      "job": "Bạn có chắc muốn xóa công việc?",
    },
    "confirmLocation": {
      "content": "Bạn có chắc muốn ngưng kích hoạt chi nhánh?",
      "no": "KHÔNG",
      "yes": "ĐỒNG Ý"
    },
    "confirmDisconnectLocation": {
      "content": "Bạn có chắc muốn ngắt kết nối chi nhánh?",
      "no": "KHÔNG",
      "yes": "ĐỒNG Ý"
    },
    "confirmMasterList": {
      "contentDisable": "Bạn có chắc muốn ngưng kích hoạt ",
      "contentEnable": "Bạn có chắc muốn kích hoạt ",
      "contentDelete": "Bạn có chắc muốn xóa ",
      "errDialog": "Mục này đã được sử dụng cho cơ sở dữ liệu khử trùng."
    },
    "confirmInstruction": {
      "contentDelete": "Bạn có chắc muốn xóa bài hướng dẫn?"
    },
    "confirmEmail": {
      "contentDelete": "Bạn có chắc muốn xóa địa chỉ email này?"
    },
    "confirmUnit": {
      "contentRemove": "Bạn có chắc muốn gỡ bỏ phòng này?",
      "contentRemoveController": "Bạn có chắc muốn gỡ bỏ bộ điều khiển này?"
    },
    "confirmCustomer": {
      "contentDisable": "Bạn có chắc muốn ngưng kích hoạt khách hàng"
    },
    "viewMember": {
      "content": "Có tất cả <%= size %> thành viên trong nhóm này."
    },
    "continueTreatmentRequest": {
      "content": "Yêu cầu khử trùng <strong><%= number %></strong> sẽ tiếp tục với ngày bắt đầu và kết thúc mới.<br />Bạn có chắc muốn tiếp tục yêu cầu khử trùng? "
    },
    "importTreatmentRequest": {
      "content": "Bạn có chắc muốn nhập tham số?"
    },
    "deleteEquipment": {
      "content": "Bạn có chắc muốn xóa thiết bị?"
    },
    "deleteJob": {
      "content": "Bạn có chắc muốn xóa công việc này?"
    },
    "finishJob": {
      "content": "Bạn có chắc muốn hoàn thành công việc này?"
    },
    "resetOperatingTime": {
      "content": "Bạn có chắc muốn reset lại thời gian vận hành của thiết bị này?"
    },
    "deleteVariable": {
      "content": "Bạn có chắc muốn xóa tham số?"
    },
    "deleteVariables": {
      "content": "Bạn có chắc muốn xóa {number} tham số?"
    },
    "removeVariable": {
      "content": "Bạn có chắc muốn xóa tham số?"
    },
    "removeVariables": {
      "content": "Bạn có chắc muốn xóa {number} tham số?"
    },
    "redButton": {
      "content1": "Bạn có chắc muốn bắt đầu khử trùng này?",
      "content2": "Bạn có chắc muốn ngừng khử trùng này?"
    },
    "notTreatment": {
      "start": "Vui lòng tạo yêu cầu điều trị trước khi bắt đầu",
    },
    "greenButton": {
      "content1": "Bạn có chắc muốn bật {name}?",
      "content2": "Bạn có chắc muốn tắt {name}?"
    },
    "start": {
      "treatmentRequest": "Bạn có chắc muốn bắt đầu yêu cầu khử trùng?",
    },
    "stop": {
      "treatmentRequest": "Bạn có chắc muốn ngừng yêu cầu khử trùng?",
    },
    "close": {
      "failureTracking": "Bạn có chắc muốn đóng sự cố?",
    },
    "send": {
      "shipmentCertificate" : "Bạn có chắc muốn gửi chứng thư?"
    },
    "cancel": {
      "shipmentCertificate" : "Bạn có chắc muốn hủy chứng thư <strong>#<%= number %></strong>?"
    },
  },
  "equipment": {
    "equipmentName": "Tên thiết bị",
    "totalTime": "Tổng thời gian (giờ)",
    "totalTimeHours": "Tổng thời gian (giờ)",
    "operatingTime": "Thời gian hoạt động (giờ)",
    "remainingTime": "Thời gian còn lại (giờ)",
    "file": "Tệp tin",
    "attachFile": "Đính kèm tập tin",
    "clickToAttach": "Bấm vào để đính kèm...",
    "jobs": "CÔNG VIỆC",
    "equipments": "THIẾT BỊ"
  },
  "job": {
    "jobName": "Tên công việc",
    "maintenanceDate": "Ngày bảo trì",
    "estimatedTimeRemaining": "Thời gian ước tính còn lại",
    "notes": "Ghi chú",
    "file": "Tệp tin",
    "attachFile": "Đính kèm tập tin",
    "newNote": "Thêm ghi chú mới",
    "days": "Ngày",
  },
  "locationColumn": {
    "customerName": "Tên công ty",
    "locationName": "Tên chi nhánh",
    "address": "Địa chỉ",
    "shipmentAddress": "Địa chỉ chứng thư đi hàng",
    "timeZone": "Múi giờ",
    "localTimeZone": "Múi giờ địa phương",
    "contact": "Liên hệ",
    "unit": "Phòng",
    "device": "Bộ điều khiển",
    "createdDate": "Ngày tạo",
    "action": "Thao tác",
    "remark": "Ghi chú",
    "controller": "Bộ điều khiển",
    "status": {
      "Active": "Hoạt động",
      "Inactive": "Ngưng hoạt động",
      "All": "Tất cả"
    }
  },
  "message": {
    "noRemainProduct": "Sản phẩm này đã hết",
    "noRequestRequired": "Số lượng/trọng lượng yêu cầu là bắt buộc",
    "required": "Trường này là bắt buộc",
    "invalid": "Trường này không hợp lệ.",
    "email_exist": "Người dùng này đã có tài khoản.",
    "group_required": "Ít nhất phải chọn một nhóm quyền.",
    "license_location_duplicated": "Chi nhánh này đã có giấy phép khác.",
    "license_clientKey_duplicated": "Client key này đã có giấy phép khác.",
    "locationName_exist": "Tên chi nhánh đã tồn tại, vui lòng đổi tên chi nhánh khác.",
    "address_exist": "Địa chỉ đã tồn tại, vui lòng thay đổi địa chỉ khác.",
    "errLocationNameArr": "Địa chỉ này đã tồn tại, vui lòng kiểm tra lại.",
    "service_unavailable": "Dịch vụ chưa sẵn sàng.",
    "bad_request": "Yêu cầu không hợp lệ. Vui lòng kiểm tra lại biểu mẫu của bạn.",
    "internal_server_error": "Lỗi máy chủ nội bộ. Vui lòng thử lại sau.",
    "empty_content_about": "Trường này là bắt buộc",
    "item_isUsed": "Mục này đã được sử dụng cho cơ sở dữ liệu khử trùng.",
    "treatmentName_exist": "Mục này đã tồn tại.",
    "err_subject_instruction": "Tiêu đề hướng dẫn phải nhỏ hơn hoặc bằng 150 ký tự",
    "max_lenght": "{_field_} không thể nhiều hơn {length} ký tự.",
    "field_required": "{_field_} không thể để trống.",
    "field_numberic": "{_field_} phải là dạng số.",
    "unitName_exist": "Tên phòng đã tồn tại, vui lòng thay đổi tên khác.",
    "phoneNumber_numberic": "Số điện thoại phải là dạng số.",
    "email": "Email không hợp lệ.",
    "emailAddress_exist": "Địa chỉ email đã tồn tại.",
    "companyName_exist": "Tên công ty đã tồn tại.",
    "phoneNumber_exist": "Số điện thoại đã tồn tại.",
    "treatment_database_exist": "Bộ dữ liệu sản phẩm, đóng gói & kỹ thuật đã bị trùng",
    "treatment_request_used": "Dữ liệu khử trùng này đã được sử dụng cho một yêu cầu khử trùng",
    "unit_variable_startstop_duplicate": "Phòng được chọn đã có tham số khác được đánh dấu Bắt đầu / dừng",
    "unit_variable_o2up_duplicate": "Phòng được chọn đã có tham số khác được đánh dấu Tăng O2",
    "unit_variable_o2downtime_duplicate": "Phòng được chọn đã có tham số khác được đánh dấu Thời gian giảm O2 còn lại",
    "unit_variable_greenbutton_duplicate": "Phòng được chọn đã có tham số khác được đánh dấu Nút xanh",
    "unit_variable_memory_duplicate": "Tên vùng nhớ trùng với tên vùng nhớ trên hệ thống",
    "unit_variable_memory_invalid": "Tên vùng nhớ không hợp lệ",   
    "controller_ipAddress_duplicate": "Địa chỉ IP là duy nhất cho 1 chi nhánh",
    "controller_name_duplicate": "Tên bộ điều khiển là duy nhất cho 1 chi nhánh",
    "blank_variable_name": "Có giá trị trống trong cột tên tham số",
    "blank_variable_memory_name": "Có giá trị trống trong cột vùng nhớ",
    "blank_variable_type_name": "Có giá trị trống trong cột loại",
    "invalid_variable_type": "Chỉ được nhập loại với Bool / Byte / UByte / Word / Floating / Time",
    "invalid_variable_checkbox": "Chỉ được dùng biểu tượng x để chọn đánh checkbox trong tập tin",
    "treatment_monitoring_startstop_o2up_invalid": "Phòng này chưa có đủ tham số Bắt đầu / Ngừng và Tăng O2",
    "treatment_monitoring_green_button_invalid": "Phòng này chưa có đủ tham số cho Nút Xanh",
    "equipment_file_format_invalid": "Định dạng tệp tin không hợp lệ",
    "startDate_before_current_endDate": "Đã có yêu cầu khử trùng khác trong cùng phòng này bị trùng ngày bắt đầu & ngày kết thúc.",
    "invalid_start_date": "Ngày bắt đầu không thể trước ngày hiện tại",
    "invalid_end_date": "Ngày kết thúc không thể trước ngày bắt đầu",
    "unit_variable_variablename_duplicate": "Tên biến phải là duy nhất cho một bộ điều khiển",
    "must_be_at_least_1_setpoint_in_treatment_db": "Phải có ít nhất 1 tham số mục tiêu trong dữ liệu khử trùng",
    "emailAddress_not_valid": "Không thể tìm thấy địa chỉ email của người dùng được chỉ định.",
    "invalid_date_time": "Thời gian không hợp lệ",
    "license_expiration_must_after_registration_date": "Ngày hết hạn phải sau ngày đăng ký",
    "required_template": "Cần ít nhất 1 mẫu trong mỗi giai đoạn",
    "phase_2_needs_at_least_1_action_for_reaching_setpoint": "Giai đoạn 2 cần ít nhất 1 hành động đạt tham số mục tiêu",
    "rpa_unit_already_exist": "Phòng đang chọn đã có RPA",
    "already_treatment_in_unit": "Đã có khử trùng Đang yêu cầu hoặc Đang chạy trong phòng",
    "auto_stop_invalid": "Ngày tự động dừng không thế trước ngày hiện tại",
	  "controller_variable_running_treatment" : "Tham số của bộ điều khiển này đang được sử dụng cho một khử trùng trong phòng",
    "unit_running_treatment": "Phòng này đang có khử trùng",
    "unit_variable_inprogress_duplicate": "Phòng được chọn đã có tham số khác được đánh dấu Trong tiến trình",
    "unit_variable_recorddata_duplicate": "Phòng được chọn đã có tham số khác được đánh dấu Ghi dữ liệu",
    "unit_variable_icon_duplicate": "Phòng được chọn đã có một biến khác được chọn cùng một biểu tượng",
    "unit_is_O2_up": "Phòng đang bơm O2",
    "treatment_request_add_weight":"Không thể tiếp tục khử trùng bị hủy này vì nó đã được tính vào khối lượng xin chứng thư đi tàu",
    "already_treatment_in_unit ":"Không thể tiếp tục vì đã có khử trùng Đang yêu cầu hoặc Đang chạy trong phòng",
    "write_variable_error ":"Không thể kết nối ứng dụng. Vui lòng kiểm tra lại mạng",
    "sync_not_offline_mode ":"Chi nhánh này ở chế độ trực tuyến",
    "sync_has_in_progress_treatments":"Chi nhánh này đang trong tiến trình khử trùng",
    "sync_location_not_exist ":"Chi nhánh này không tồn tại",
    "a_bool_variable_can_only_be_ticked": "Tham số dạng bool chỉ được phép đánh dấu 1 trong các cột sau Báo động / Bắt đầu hoặc dừng / Tăng O2 / Nút xanh / Tham số / Tham số hiệu chỉnh / (Đang chạy và Báo động không thể cùng được chọn)",
    "a_bool_variable_can_not_be_ticked_home_remainingO2DownTime": "Tham số dạng bool không thể đánh dấu Trang chủ / Thời gian giảm O2 còn lại",
    "a_byte/floating_variable_can_only_be_ticked": "Tham số dạng Byte / UByte / Word / Floating không thể đánh dấu 1 trong các cột sau Báo động / Bắt đầu hoặc dừng / Tăng O2 / Nút xanh / Thời gian hoạt động / Đang chạy / Ghi nhận dữ liệu / Thời gian giảm O2 còn lại",
    "a_time_variable_can_only_be_ticked": "Tham số dạng Time không thể đánh dấu 1 trong các cột sau Báo động / Bắt đầu hoặc dừng / Tăng O2 / Nút xanh / Thời gian hoạt động / Đang chạy / Ghi nhận dữ liệu / Trang chủ / Biểu đồ",
    "unit_variable_icon_invalid_type": "Các biến kiểu bool mới được chọn icon.",
    "variable_unit_running": "Tham số này thuộc về phòng đang chạy khử trùng",
    "expiry_time_must_have_the_same_among_records": "Sản phẩm này đã tồn tại ở dữ liệu khử trùng khác nên cần nhập thời gian hết hạn giống nhau",
    "invalid_location_connection": "Không thể kết nối ứng dụng khách. Vui lòng kiểm tra mạng khách hàng.",
    "check_session_fail": "Không thể kiểm tra phiên đăng nhập. <br/> Vui lòng liên hệ với quản trị viên của bạn để đảm bảo rằng bạn có quyền phù hợp",
    "invite": "Bạn không có quyền mời người dùng. Vui lòng liên hệ với quản trị viên của bạn để cấp quyền chia sẻ cho tài khoản của bạn",
    "user-not-found": "Không tìm thấy người dùng"
  },
  "notification": {
    "type": {
      "TREATMENT_CREATED": "Chi nhánh {locationName}: Yêu cầu khử trùng <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> đã được tạo lúc {dateTime}",
      "TREATMENT_UPDATED": "Yêu cầu khử trùng <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> đã bị hủy vào lúc {dateTime} bởi vì một khử trùng khác  đang chạy trong phòng đã được gia hạn thời gian khử trùng.",
      "TREATMENT_CONTINUE_AFTER_CANCELING": "Yêu cầu khử trùng <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> đã bị hủy vào lúc {dateTime} because another Cancelled treatment in the same unit has been continued & extended the treatment time",
      "TREATMENT_CONTINUE": "Yêu cầu khử trùng <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> has been reseted at {dateTime}",
      "TREATMENT_START": "Chi nhánh {locationName}: Yêu cầu khử trùng <span code=\"TREATMENT_START\" class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\" unitId=\"{unitId}\">{treatmentNumber}</span> đã bắt đầu vào lúc {dateTime}",
      "TREATMENT_STOP": "Chi nhánh {locationName}: Yêu cầu khử trùng <span code=\"TREATMENT_STOP\" class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\" unitId=\"{unitId}\" >{treatmentNumber}</span> đã ngừng vào lúc {dateTime}",
      "TREATMENT_FINISH": "Chi nhánh {locationName}: Yêu cầu khử trùng <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> đã tắt vào lúc {dateTime}",
      "ALARM_ON": "Chi nhánh {locationName}: <span class=\"todo\">{variableName}</span> trong <span class=\"todo\">{unitName}</span> vào lúc <span>{dateTime}</span>; <span class=\"todo\">{recommendedAction}</span>",
      "ALARM_OFF": "Chi nhánh {locationName}: <span class=\"todo\">{variableName}</span> đã được tắt trong <span class=\"todo\">{unitName}</span> vào lúc <span>{dateTime}</span>",
      "TREATMENT_MONITORING_RECOUNTING": "Chi nhánh {locationName}: Có lỗi xãy ra vào lúc {dateTime} mà cần đếm lại thời gian khử trùng <span code=\"TREATMENT_RECOUNT\" class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\" unitId=\"{unitId}\" >{treatmentNumber}</span>",
      "TREATMENT_MONITORING_REACHED": "Chi nhánh {locationName}: Khử trùng số  <span code=\"TREATMENT_REACHED\" class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\" unitId=\"{unitId}\" >{treatmentNumber}</span> đã đạt tham số mục tiêu {setPointName} vào lúc {dateTime}",
      "TREATMENT_MONITORING_EXPECTED_END_DATE": "Chi nhánh {locationName}: Thời gian kết thúc dự kiến của khử trùng số <span code=\"TREATMENT_REACHED_ALL\" class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\" unitId=\"{unitId}\" >{treatmentNumber}</span> là {dateTime}",
      "TREATMENT_MONITORING_TECHNICAL_CHECKING": "Chi nhánh {locationName}: Có lỗi kỹ thuật của khử trùng <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> ở trong {unitName} vào lúc {dateTime}. Phase {phase} - {ruleName} - {action}.",
      "TREATMENT_MONITORING_STOP_UNIT": "{unitName} ở chi nhánh {locationName} đã được hoàn thành vào lúc {dateTime}",
      "TREATMENT_MONITORING_WAITING_FOR_TECHNICAL_CHECKING": "Chi nhánh {locationName}: Đã có lỗi xảy ra của khử trùng <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span>  vào lúc {dateTime}. Xin chờ việc kiểm tra kỹ thuật trước khi bắt đầu khử trùng ở phòng {unitName}. Phase {phase} - {ruleName} - {action}.",
      "CONTROLLER_DISCONNECTION": "Chi nhánh {locationName} đã mất kết nối với bộ điều khiển {controllerName} vào lúc {dateTime}",
      "TREATMENT_MONITORING_OUT_OF_REACH":"Chi nhánh {locationName}: Khử trùng số <span code=\"TREATMENT_OUT_OF_REACH\" class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\" unitId=\"{unitId}\" >{treatmentNumber}</span> đã không đạt tham số mục tiêu {setPointName} vào lúc {dateTime}",
      "CONTROLLER_RECONNECTION":"Chi nhánh {locationName} đã được kết nối lại với bộ điều khiển {controllerName} vào lúc {dateTime}",
      "LOCATION_MAINTENANCE_DATE":"Chi nhánh {locationName} cần được bảo trì vào {dateTime}",
      "EQUIPMENT_MAINTENANCE_DATE":"Chi nhánh {locationName}: Thời gian còn lại của thiết bị {equipmentName} còn lại {equipmentRemainingTime} giờ vào lúc {dateTime}",
      "JOB_MAINTENANCE":"Chi nhánh {locationName} cần được bảo trì vào {maintenanceDate} với tên công việc là {jobName}",
      "CLIENT_APP_RECONNECTION":"Chi nhánh {locationName} đã được kết nối lại với ECO2 Server vào lúc {dateTime}",
      "CLIENT_APP_DISCONNECTION":"Chi nhánh {locationName} đã mất kết nối với ECO2 Server vào lúc {dateTime}",
      "FAIL_WRITE_TO_PLC":"Chi nhánh {locationName}: Không cập nhật được giá trị: {value} của tham số {variableName} trên {unitName} lúc {dateTime}. Giá trị trước đó sẽ được giữ lại",
    }
  },
  "page": {
    "user": {
      "status": {
        "NEW": "Mới",
        "ACTIVE": "Kích hoạt",
        "INACTIVE": "Ngưng kích hoạt",
        "INVITED": "Được mời"
      },
      "organization": {
        "CLIENT": "Khách hàng",
        "ECO2": "Eco2"
      }
    },
    "group": {
      "ADMINISTRATOR": "Quản trị viên",
      "MANAGER": "Quản lý",
      "TECHNICIAN": "Kỹ thuật viên",
      "OPERATOR": "Nhân viên vận hành",
      "CLIENT": "Khách hàng",
      "SPECIAL_EDITOR": "Biên tập viên đặc biệt",
      "Administrator": "Quản trị viên",
      "Manager": "Quản lý",
      "Technician": "Kỹ thuật viên",
      "Operator": "Nhân viên vận hành",
      "Client": "Khách hàng",
      "Client_Request": "Khách hàng (khử trùng)",
      "Client shipment": "Khách hàng (shipment)"
    },
    "permission": {
      "CUSTOMER_MANAGEMENT": "Customer Management",
      "CUSTOMER_MANAGEMENT|ACTIVATE_DEACTIVATE": "Active/Deactivate",
      "LOCATION_MANAGEMENT": "Location Management",
      "LOCATION_MANAGEMENT|ACTIVATE_DEACTIVATE": "Active/Deactivate",
      "UNIT_MANAGEMENT": "Unit Management",
      "UNIT_MANAGEMENT|CALIBRATION_PARAMETERS": "Calibration parameters",
      "UNIT_MANAGEMENT|SETUP_PARAMETERS": "Setup parameters",
      "USER_MANAGEMENT": "User Management",
      "USER_MANAGEMENT|ASSIGN_LOWER_ROLE": "Assign lower role",
      "USER_MANAGEMENT|ACTIVATE_DEACTIVATE": "Active/Deactivate",
      "TREATMENT_DATABASE_MANAGEMENT": "Treatment Database Management",
      "DEVICE_MANAGEMENT": "(PLC) Device Management",
      "TREATMENT_MANAGEMENT": "Treatment Management",
      "TREATMENT_MANAGEMENT|START_STOP_CONTINUE": "Start/Stop/Continue",
      "TREATMENT_MANAGEMENT|VIEW_CERTIFICATE": "View Certificate",
      "TREATMENT_MANAGEMENT|EDIT_FINISHED_REQUEST": "Edit Finished Treatment Request",
      "TREATMENT_MONITORING_FOR_UNIT": "Treatment Monitoring for Unit",
      "TREATMENT_MONITORING_FOR_UNIT|UPDATE_PARAMETERS": "Update parameters",
      "TREATMENT_MONITORING_FOR_UNIT|UPDATE_C_PARAMETERS": "Update c.parameters",
      "TREATMENT_MONITORING_FOR_UNIT|RED_BUTTON": "Red button",
      "TREATMENT_MONITORING_FOR_UNIT|GREEN_BUTTON": "Green button",
      "TREATMENT_MONITORING_FOR_UNIT|RECOUNT_TREATMENT_TIME": "Recount treatment time",
      "FAILURE_TRACKING_MANAGEMENT": "Failure Tracking Management",
      "FAILURE_TRACKING_MANAGEMENT|EXPORT": "Export",
      "MAINTENANCE_TRACKING_MANAGEMENT": "Maintenance Tracking Management",
      "MAINTENANCE_TRACKING_MANAGEMENT|EXPORT": "Export",
      "FCM_PUSH_NOTIFICATION_MANAGEMENT": "FCM Push Notification Management (Mobile)",
      "NOTIFICATION_MANAGEMENT": "Receive Notification",
      "MAILING_LIST_MANAGEMENT": "Mailing List Management",
      "SHIPMENT_CERTIFICATE_REPORTS": "Shipment Certificate Reports (FM04, FM05, FM06)",
      "SHIPMENT_CERTIFICATE_REPORTS|APPROVE_REJECT": "Approve/Reject",
      "LICENSE_MANAGEMENT": "License Management",
      "LICENSE_MANAGEMENT|ACTIVATE_DEACTIVATE": "Active/Deactivate",
      "ACTIVITY_LOGS": "Activity Logs",
      "OPERATION_INSTRUCTION": "Operation Instruction (Blogs)",
      "INFORMATION_PAGES": "RPA Management",
      "DASHBOARD_AND_REPORTS": "Dashboard and Reports",
      "ABOUT_PAGE": "About Page (Public Page)",
      "GROUP_MANAGEMENT": "Group Management",
      "CONTROLLER_MANAGEMENT": "Controller Management",
      "VARIABLES_MANAGEMENT": "Variables Management",
      "VARIABLES_MANAGEMENT|IMPORT_EXPORT": "Import/Export",
      "RPA_MANAGEMENT": "RPA Management",
      "RPA_MANAGEMENT|COPY": "Copy",
      "RECEIVE_NOTIFICATION": "Receive Notification",
      "LICENSE": "License",
      "LICENSE_LIST": "License List",
      "ONLINE_MODE": "Online Mode",
      "ONLINE_MODE|ACTIVE": "Active",
      "LICENSE|ACTIVE": "Active",
      "WEB_CONFIG": "Web Config",
    }
  },
  "text": {
    "DAYS": "Ngày",
    "HOURS": "Giờ",
    "MINUTES": "Phút",
    "MONTHS": "Tháng",
    "O2Level": "Nồng độ O2",
    "RPA": "RPA",
    "WEEKS": "Tuần",
    "aboutUs": "Giới thiệu",
    "action": "Thao tác",
    "active": "Đang hoạt động",
    "addController": "Thêm bộ điều khiển",
    "addEquipment": "Thêm thiết bị",
    "addMaintenanceJob": "Thêm việc bảo trì",
    "maintenanceDate": "Ngày bảo trì",
    "finishJob": "Hoàn thành",
    "addInsect": "Thêm côn trùng",
    "addLocationText": "Thêm chi nhánh",
    "addMail": "Thêm email",
    "addPackage": "Thêm loại đóng gói",
    "addProduct": "Thêm sản phẩm",
    "addSetpoint": "Thêm Tham số mục tiêu",
    "addSetpointPara": "Thêm Tham số mục tiêu",
    "addTechnique": "Thêm kỹ thuật",
    "addUnit": "Thêm phòng",
    "addVariable": "Thêm tham số",
    "addVariablesTo": "Thêm tham số vào phòng",
    "address": "Địa chỉ",
    "airTempt": "Nhiệt độ không khí",
    "alarm": "Báo động",
    "all": "Tất cả",
    "allVariable": "TẤT CẢ THAM SỐ",
    "approved": "Được duyệt",
    "assignProductsToEachUnit": "Sản phẩm được đưa vào phòng",
    "atTime": "lúc",
    "basicInformationForThisTreatment": "Location sẽ khử trùng",
    "by": "BỞI",
    "calibrationParameter": "Tham số hiệu chỉnh",
    "cancelled": "Bị hủy",
    "changeGroupName": "Đổi tên nhóm",
    "changeName": "Đổi tên nhóm",
    "changeStatus": "Thay đổi trạng thái",
    "changeStatusDescription": "Cho phép chuyển đổi trạng thái giữa 'Hoàn thành' và 'Bị hủy'",
    "additionalInformation": "Thông tin bổ sung",
    "editFinishedRequestFields": "Chỉnh sửa các trường cho request đã hoàn thành",
    "clickToView": "BẤM ĐỂ XEM",
    "clickToViewLowerCase": "Bấm để xem",
    "companyName": "Tên công ty",
    "confirm": "Xác nhận",
    "contact": "Liên hệ",
    "content": "NỘI DUNG BÀI VIẾT",
    "contentLicense": "NỘI DUNG",
    "continue": "Tiếp tục",
    "continueTreatment": "Tiếp tục khử trùng",
    "controller": "Bộ điều khiển",
    "controllerDescription": "Mô tả",
    "controllerName": "Tên",
    "controllerVariableMemory": "Vùng nhớ",
    "controllerVariableName": "Tên",
    "controllers": "Bộ điều khiển",
    "country": "Quốc gia",
    "create": "Tạo",
    "createdAt": "TẠO LÚC",
    "createdBy": "Tạo bởi",
    "createdDate": "Ngày tạo",
    "customer": "Khách hàng",
    "dateClosed": "Ngày đóng sự cố",
    "dateOpen": "Ngày xảy ra sự cố",
    "delete": "Xóa",
    "disable": "Ngưng kích hoạt",
    "disconnect": "Ngắt kết nối",
    "edit": "Sửa",
    "editController": "Chỉnh sửa bộ điều khiển",
    "editEquipment": "Chỉnh sửa thiết bị",
    "editMail": "Chỉnh sửa email",
    "editUnit": "Chỉnh sửa phòng",
    "editVariable": "Chỉnh sửa tham số",
    "email": "Email",
    "emailAddress": "Địa chỉ email",
    "enable": "Kích hoạt",
    "endDate": "Ngày kết thúc",
    "error": "Lỗi",
    "expectedEndDate": "Ngày kết thúc dự kiến",
    "failureEvents": "Sự cố",
    "failureName": "Tên sự cố",
    "faxNumber": "Số fax",
    "finished": "Đã hoàn thành",
    "finishedTreatments": "Khử trùng đã hoàn thành",
    "format": "Định dạng",
    "fromDate": "Từ ngày",
    "fullName": "Họ tên",
    "function": "Tính năng",
    "generalInformation": "Thông tin chung",
    "greenButton": "Nút xanh",
    "group": "Nhóm",
    "groupName": "Tên nhóm",
    "headTitle": "Tiêu đề bài viết",
    "headerImageUrl": "Hình ảnh đầu bài viết",
    "home": "Trang chủ",
    "icon": "Biểu tượng",
    "inProgress": "Đang tiến hành",
    "inRequest": "Đang yêu cầu",
    "inactive": "Ngừng hoạt động",
    "information": "Thông tin",
    "inletTempt": "Nhiệt độ đầu vào",
    "insect": "Côn trùng",
    "insectName": "Tên côn trùng",
    "instructionSubject": "Tiêu đề bài Hướng dẫn",
    "instructions": "Hướng dẫn",
    "ipAddress": "Địa chỉ IP",
    "ipAddressAndController": "Địa chỉ IP và bộ điều khiển",
    "keyword": "Từ khóa",
    "keywordSearch": "Tìm bằng từ khóa...",
    "keywords": "Từ khóa",
    "language": "Language",
    "lastEdited": "Chỉnh sửa lần cuối bởi",
    "lastEditedAt": "Chỉnh sửa lần cuối lúc",
    "lastEditedBy": "Chỉnh sửa lần cuối bởi",
    "learnMore": "Xem thêm",
    "location": "Chi nhánh",
    "locationName": "Tên chi nhánh",
    "locationSearch": "Tên công ty, Tên chi nhánh, Địa chỉ",
    "locations": "Chi nhánh",
    "lotBatchNumbers": "Số lô",
    "mailAlarm1": "Bắt đầu / ngừng / tiếp tục / hủy khử trùng",
    "mailAlarm2": "Đạt tham số mục tiêu / thời gian dự kiến",
    "mailAlarm3": "Báo động",
    "mailCustomer": "",
    "mailLocation": "Chi nhánh",
    "mailingList": "Danh sách email",
    "members": "Thành viên",
    "monitoringSearchRequired": "Vui lòng chọn khách hàng/chi nhánh để xem.",
    "monitoringSearchText": "Chọn khách hàng/chi nhánh để xem",
    "myProfile": "My Profile",
    "no": "Số thứ tự",
    "notificationType": "Loại thông báo",
    "notifyWhen": "Thông báo khi:",
    "numberOfPackages": "Số lượng đóng gói",
    "packaging": "Loại đóng gói",
    "numberOfPallets": "Số lượng kệ kê hàng",
    "specificationOfProduct": "Phân loại sản phẩm",
    "o2Up": "Tăng O2",
    "operationTime": "Thời gian hoạt động",
    "organization": "Tổ chức",
    "organizations": "Organizations",
    "package": "Đóng gói",
    "packageName": "Tên loại đóng gói",
    "parameter": "Tham số",
    "permissions": "Quyền",
    "phoneNumber": "Số điện thoại",
    "treatmentAddress": "Địa chỉ khử trùng",
    "product": "Sản phẩm",
    "productInformation": "Thông tin sản phẩm",
    "productName": "Tên sản phẩm",
    "productTempt": "Nhiệt độ sản phẩm",
    "profileImage": "Ảnh đại diện",
    "read": "Xem",
    "readonly": "Chỉ xem",
    "recommendedActions": "Hành động đề xuất",
    "rejected": "Bị từ chối",
    "remainingO2DownTime": "Thời gian còn lại",
    "remark": "Ghi chú",
    "removeUnit": "Xóa phòng",
    "search": "Tìm kiếm",
    "searchLabelCustomer": "Tên công ty, Email, Địa chỉ, Số điện thoại, ...",
    "setpoint": "Tham số mục tiêu",
    "setpointName": "Tên tham số mục tiêu",
    "setpointNamePara": "Tên tham số mục tiêu",
    "setpointParameters": "Tham số mục tiêu",
    "shipmentCertificates": "Chứng thư đi tàu",
    "shipmentCertifications": "Chứng thư đi tàu",
    "shortDescription": "Tóm tắt bài viết",
    "specialRequest": "Yêu cầu khử trùng đặc biệt",
    "start": "Bắt đầu",
    "startDate": "Ngày bắt đầu",
    "startTreatment": "Bắt đầu yêu cầu khử trùng",
    "startStop": "Bắt đầu / Dừng",
    "status": "Trạng thái",
    "stop": "Ngừng ",
    "taxID": "Mã số thuế",
    "technique": "Kỹ thuật",
    "techniqueName": "Tên kỹ thuật",
    "thisSectionWillDetermineWhichSetpointIsFitForTheProduct": "Treatment database của khử trùng",
    "titlePublicInstruction": "Vui lòng xem trước bài viết trước khi đăng",
    "toDate": "Đến ngày",
    "total": "Tổng cộng",
    "totalCustomers": "Tổng số khách hàng",
    "totalLocations": "Tổng số chi nhánh",
    "totalUnits": "Tổng số phòng",
    "totalWeightKG": "Tổng khối lượng(KG)",
    "treatmentInRequest": "Khử trùng đang yêu cầu",
    "treatmentNR": "Số khử trùng",
    "treatmentRequests": "Yêu cầu khử trùng",
    "originals": "Bảng gốc",
    "treatmentTime": "Thời gian khử trùng",
    "treatmentType": "Loại khử trùng",
    "treatmentsInProgress": "Khử trùng đang tiến hành",
    "type": "Loại",
    "unit": "Phòng",
    "units": "Phòng",
    "unitDescription": "Mô tả",
    "unitName": "Tên",
    "unitNameText": "Tên phòng",
    "unitType": "Loại",
    "zone": "Khu vực",
    "noneTreatment": "Không khử trùng",
    "update": "Cập nhật",
    "updateInsect": "Cập nhật côn trùng",
    "updateLocationText": "Chỉnh sửa chi nhánh",
    "updatePackage": "Cập nhật loại đóng gói",
    "updateProduct": "Cập nhật sản phẩm",
    "updateSetpoint": "Cập nhật Tham số mục tiêu",
    "updateTechnique": "Cập nhật kỹ thuật",
    "updatedDate": "Ngày cập nhật",
    "userGroup": "Nhóm người dùng",
    "users": "Người dùng",
    "variable": "Tham số",
    "variableName": "Tên tham số",
    "variableToAdd": "THAM SỐ ĐỂ THÊM",
    "variables": "Tham số",
    "view": "Xem",
    "viewCertificate": "Xem chứng chỉ",
    "viewLocation": "Xem chi nhánh",
    "viewPermissions": "Xem quyền",
    "viewUsers": "Xem thành viên",
    "parameterOfUnit": "Tham số của phòng",
    "parameterOfController": "Tham số của bộ điều khiển",
    "Normal": "Tiêu chuẩn",
    "Special": "Đặc biệt",
	  "Closed": "Đã đóng",
    "Open": "Đang mở",
    "lastChangedBy": "Thay đổi lần cuối bởi",
    "describe": "Mô tả",
    "causeOfFailure": "Nguyên nhân sự cố",
    "solution": "Giải pháp",
    "close": "Đóng",
    "basicInformationForThisFailureEvent": "Thông tin cơ bản của sự cố.",
    "failureInformation": "Thông tin sự cố",
    "failureEventRelatedInformationAndMore": "Thông tin liên quan đến sự cố.",
    "objectName": "Tên hoạt động",
    "oldValue": "Giá trị cũ",
    "newValue": "Giá trị mới",
    "dateTime": "Thời gian",
    "eventInitiated": "Hoạt động bắt đầu bởi",
    "licenseNumber": "Mã số giấy phép",
    "expirationDate": "Ngày hết hạn",
    "isSendOfflineMail": "Gửi Thư Ngoại Tuyến",
    "addLicense": "Thêm giấy phép",
    "editLicense": "Chỉnh sửa giấy phép",
    "certificateId": "Mã chứng thư",
    "treatmentId": "Mã số khử trùng",
    "totalUndercertificatedWeight": "Tổng khối lượng chưa cấp chứng thư (KG)",
    "requestWeight": "Khối lượng yêu cầu (KG)",
    "remainingWeight": "Khối lượng còn lại (KG)",
    "requestPallet": "Số lượng Pallet yêu cầu (PCS)",
    "remainingPallet": "Số lượng Pallet còn lại (PCS)",
    "fee": "Phí",
    "bill": "Hóa đơn ",
    "sealno": "Mã số Container / Seal",
    "blno": "Mã số vận đơn",
    "vesselname": "Tên tàu",
    "shipmentRequest": "Yêu cầu chứng thư đi tàu",
    "shipmentInfo": "Thông tin cơ bản của chứng thư.",
    "consigneeName": "Tên người nhận hàng",
    "portLoading": "Tên cảng vận chuyển",
    "finalDestination": "Địa chỉ tàu vận chuyển đến",
    "shipmentPackaging": "Đóng gói vận chuyển",
    "clientReference": "Mã tham chiếu khách hàng",
    "shipper": "Tên đơn vị vận chuyển",
    "treatmentMonitoringAlarm": "Xem báo động và kiểm tra các giải pháp.",
    "parameters": "Tham số",
    "proceedTime": "Thời gian tiến hành",
    "dataLog": "Nhật ký dữ liệu",
    "changeChart": "Thay đổi biểu đồ",
    "selected": "Đã chọn",
    "value": "Giá trị",
    "proceedTimeHHmm": "Thời gian tiến hành(HH:MM)",
    "find": "Tìm kiếm",
    "shipmentWeight": "Tính khối lượng vào chứng thư xin đi tàu",
    "shipmentWithoutWeight": "Không tính khối lượng vào chứng thư xin đi tàu",
    "alarmType": "Loại báo động",
    "date": "Ngày",
    "time": "Thời gian",
    "draft": "Nháp",
    "send": "Gửi",
    "sendAgain": "Gửi lại",
    "free": "Miễn phí",
    "notFree": "Có phí",
    "approve": "Được duyệt",
    "reject": "Bị từ chối",
    "viewTreatmentID": "Xem mã số khử trùng",
    "registrationDate": "Ngày đăng ký",
    "Waiting": "Đang chờ",
    "Activated": "Đang kích hoạt",
    "Deactivated": "Ngừng kích hoạt",
    "reviewTitle": "Vui lòng xem trước giới thiệu trước khi đăng",
    "recordData":"Ghi nhận dữ liệu",
    "graph":"Biểu đồ",
    "rpaName": "Tên RPA",
    "RPAGeneralInformation": "Thông tin chung RPA",
    "since": "Từ khi",
    "conditionType": "Loại điều kiện",
    "comparison": "Kiểu so sánh",
    "otherVariable": "Tham số khác",
    "after": "Sau",
    "endCheckingAfter": "Dừng kiểm tra sau",
    "afterEveryInterval": "Sau mỗi khoảng thời gian",
    "afterEveryIntervalEndPhase": "Sau mỗi khoảng thời gian đến khi kết thúc giai đoạn",
    "phaseOne": "Giai đoạn 1: Trước khi bắt đầu khử trùng",
    "phaseTwo": "Giai đoạn 2: Bắt đầu khử trùng - Trước khi đạt tham số mục tiêu",
    "phaseThree": "Giai đoạn 3: Duy trì khử trùng",
    "phaseFour": "Giai đoạn 4: Sau khi dừng khử trùng",
    "beginThePhase": "Giai đoạn đầu",
    "range": "Phạm vi",
    "Down": "Giảm",
    "Up": "Tăng",
    "technicalChecking": "Kiểm tra kỹ thuật",
    "waitingTechnicalChecking": "Chờ kĩ thuật kiểm tra cho tới khi bắt đầu",
    "reachingSetpointExpectedEndTime": "Đạt tham số mục tiêu và tính thời gian kết thúc dự kiến",
    "recountTreatmentTime": "Đếm lại thời gian khử trùng",
    "addTime": "Thêm thời gian",
    "removeTime": "Bỏ thời gian",
    "otherRpa": "RPA khác",
    "treatmentRpa": "RPA cho khử trùng",
    "otherRules": "Quy tắc khác",
    "selectDataTemplate": "Chọn mẫu",
    "selectTemplate": "Chọn mẫu",
    "rule": "Quy tắc",
    "from": "Từ",
    "to": "Tới",
    "sinceABool": "Kể từ khi tham số dạng Bool được bật lên",
    "ruleName": "Quy tắc",
    "orderNo": "Thứ tự",
    "True": "Đúng",
    "False": "Sai",
    "fromOpenDate": "Ngày xảy ra sự cố",
    "toOpenDate": "Ngày đóng sự cố",
    "stopTreatment": "Ngừng khử trùng",
    "weightSetting": "THIẾT LẬP KHỐI LƯỢNG",
    "addWeightForShipmentCertificate": "Tính khối lượng vào chứng thư xin đi tàu",
    "dontAddWeightForShipmentCertificate": "Không tính khối lượng vào chứng thư xin đi tàu",
    "stopSetting": "NGỪNG THIẾT LẬP",
    "stopImmediately": "Ngừng ngây lập tức",
    "autostopDate": "Ngày tự động dừng",
    "shipmentCertificateWeight": "Khối lượng cấp chứng thư",
    "startImmediately": "Bắt đầu ngay lập tức",
    "Box": "Ô",
    "Boxes": "Ô",
    "numberParameter": "Tham số dạng số",
    "boolParameter":"Tham số dạng bật / tắt",
    "startTime": "Thời gian bắt đầu",
    "endTime": "Thời gian kết thúc",
    "treatmentID": "Mã số khử trùng",
    "licenseInformation": "Thông tin giấy phép",
    "activateLicense": "Kích hoạt giấy phép",
    "connect": "Kết nối",
    "locationId":"Mã số chi nhánh",
    "enterLocationId":"Vui lòng nhập mã số chi nhánh",
    "syncSuccess":"Kết nối thành công tới máy chủ ECO2",
    "syncInProgress":"Quá trình đồng bộ dữ liệu đang diễn ra. Vui lòng đợi cho đến khi hoàn thành.",
    "Color": "Color",
	  "allLocations": "Tất cả chi nhánh",
    "specificLocations": "Specific locations",
    "appliedTo": "Áp dụng cho",
    "expiryTime": "Thời gian hết hạn",
    "viewDetail": "Xem chi tiết",
    "appliedLocations": "Chi nhánh đã áp dụng",
    "selectLocation": "Chọn chi nhánh",
    "treatmentGraph": "Biểu đồ khử trùng",
    "pallet": "Kệ kê hàng",
    "yes": "Đúng",
    "registration": "Đăng ký",
    "registrationNo": "Đăng ký số",
    "shipmentFreetimes": "Miễn phí vận chuyển (lần)",
    "validRemainingWeight": "Khối lượng còn lại còn hạn (KG)",
    "invalidRemainingWeight": "Khối lượng còn lại đã hết hạn (KG)",
    "validRemainingPallet": "Số lượng pallet còn lại còn hạn (PCS)",
    "invalidRemainingPallet": "Số lượng pallet còn lại đã hết hạn (PCS)",
    "issueDateSuggestion": "Ngày phát hành đề xuất!",
    "desiredIssueDate": "Ngày phát hành mong muốn",
    "cancel": "Hủy",
    "approveShipmentCertificate": "Duyệt chứng thư đi hàng",
    "cancelShipmentCertificate": "Hủy chứng thư đi hàng",
    "rejectShipmentCertificate": "Từ chối chứng thư đi hàng",
    "totalRequestWeight": "Tổng (KG)/(PCS) yêu cầu",
    "totalRemainingWeight": "Tổng (KG)/(PCS) còn lại",
    "durationTreatment" : "Thời gian khử trùng",
    "durationTemperature": "Thời gian đạt nhiệt độ",
    "durationReachO2": "Thời gian đạt O2",
    "condition": "Điều kiện",
    "reachingO2Level": "Đạt nồng độ O2",
    "reachingProductTemp": "Đạt nhiệt độ sản phẩm",
    "startTemperature": "Nhiệt độ ban đầu",
    "logOut": "Đăng xuất",
    "packing": "Đóng gói",
    "resetOperatingTime": "Đặt lại thời gian hoạt động",
    "finish": "Kết thúc",
    "webConfig": "Cấu hình web",
    "graphAddress": "Địa chỉ",
    "graphPhone": "Số điện thoại",
    "graphEmail": "Email",
    "foreignStamp": "Con dấu nước ngoài",
    "vietNamStamp": "Con dấu Việt Nam",
    "palletCondition": "Điều kiện Pallet",
    "commoditiesCondition": "Điều kiện sản phẩm",
    "disableSendEmailToAdmin": "Vô hiệu hóa gửi mail cho Quản trị viên",
    "graphWebsite": "Địa chỉ web",
    "graphFooter": "Chân trang",
    "certificate": "Chứng chỉ",
    "treatmentProvider": "Người cấp",
    "treatmentSupervisor": "Người giáp sát",
    "filter": 'Bộ lọc',
    "overview": 'Tổng quan',
    "page-not-found": "Không tìm thấy trang",
    "page-not-found-description": "Ồ! Trang bạn đang tìm kiếm không tồn tại. Có thể trang đã bị di chuyển, xóa hoặc bạn đã nhập sai URL.",
    "page-not-found-go-back": "Quay lại",
    "sign-in": "Đăng nhập",
    "welcome-back": "Chào mừng trở lại!",
    "email-field": "Email",
    "enter-your-email": "Nhập email của bạn",
    "email-is-required": "Email là bắt buộc",
    "password-field": "Mật khẩu",
    "enter-your-password": "Nhập mật khẩu của bạn",
    "password-is-required": "Mật khẩu là bắt buộc",
    "or": "hoặc",
    "sign-in-ms": "Đăng nhập bằng tài khoản PCU",
    "email-must-be-valid": "Email phải hợp lệ",
    "password-length": "Mật khẩu phải có ít nhất 8 ký tự",
    "reset-password": "Đặt lại mật khẩu",
    "Please-enter-reset-password": "Vui lòng nhập mật khẩu mới cho tài khoản của bạn.",
    "new-password": "Mật khẩu mới",
    "enter-new-password": "Nhập mật khẩu mới",
    "confirm-password": "Xác nhận mật khẩu",
    "confirm-new-password": "Xác nhận mật khẩu mới",
    "confirm-password-is-required": "Vui lòng xác nhận mật khẩu",
    "passwords-do-not-match": "Mật khẩu không khớp",
    "token-invalid-or-expired": "Liên kết không hợp lệ hoặc đã hết hạn",
    "invalid-email-or-password": "Email hoặc mật khẩu không đúng",
    "forgot-password": "Quên mật khẩu",
    "notifications": "Thông báo",
  },
  "treatment": {
    "add": "Thêm dữ liệu khử trùng",
    "edit": "Sửa dữ liệu khử trùng",
    "view": "Xem dữ liệu khử trùng",
    "master_list": "CƠ SỞ DỮ LIỆU",
    "database": "DỮ LIỆU KHỬ TRÙNG",
    "status": {
      "Active": "Hoạt động",
      "Inactive": "Ngưng hoạt động"
    }
  },
  "unitColumn": {
    "name": "Tên",
    "type": "Loại",
    "rpa": "RPA",
    "description": "Mô tả",
    "variables": "Tham số",
    "freeText": "Văn bản tự do",
    "toleranceOutreachTemp": "Ngưỡng sai lệch nhiệt độ",
    "toleranceOutreachO2": "Ngưỡng sai lệch O2"
  },
  "license": {
    "edit": "Chỉnh sửa giới thiệu",
    "buttonPublic": "Đăng giới thiệu",
    "reviewText": "Vui lòng xem trước giới thiệu trước khi đăng",
  },
  "rpaTemplate": {
    "templateOne": {
      "since": "- Bắt đầu giai đoạn\n - Phạm vi từ - tới",
      "sinceABool": "Tham số",
      "variable": "Tham số",
      "type": "Byte/UByte/Word/Floating",
      "conditionType": "Down / Up",
      "comparison": ">= / > / = / < / <=",
      "value": "Số",
      "after": "- Sau\n - Sau mỗi khoảng thời gian\n - Sau mỗi khoảng thời gian đến khi kết thúc giai đoạn",
      "time": "Time",
      "package": "Đóng gói",
    },
    "templateTwo": {
      "since": "- Bắt đầu giai đoạn",
      "sinceABool": "Tham số",
      "variable": "Tham số",
      "type": "Byte/UByte/Word/Floating",
      "conditionType": "",
      "comparison": ">= / > / = / < / <=",
      "value": "Tham số khác\n(+/- Số)",
      "after": "- Sau\n - Sau mỗi khoảng thời gian\n - Sau mỗi khoảng thời gian đến khi kết thúc giai đoạn",
      "time": "Time",
      "package": "Đóng gói",
    },
    "templateThree": {
      "since": "- Bắt đầu giai đoạn",
      "sinceABool": "Tham số",
      "variable": "Tham số",
      "type": "Bool",
      "conditionType": "Là",
      "comparison": "",
      "value": "Đúng/Sai",
      "after": "- Sau\n - Sau mỗi khoảng thời gian\n - Sau mỗi khoảng thời gian đến khi kết thúc giai đoạn",
      "time": "Thời gian",
      "package": "Đóng gói",
    }
  },
  "status": {
    "OPEN": "Đang mở",
    "CLOSED": "Đã đóng",
    "INREQUEST": "Đang yêu cầu",
    "REJECTED": "Bị từ chối",
    "APPROVED": "Được duyệt",
    "DRAFT": "Nháp",
    "VALID": "Hợp lệ",
    "CANCELED": "Hủy",
    "ACCEPTED": "Được chấp nhận",
    "NEEDSUPPORT": "Cần hỗ trợ",
    "NEW": "Mới",
    "OVERDUE": "Quá hạn",
    "FINISHED": "Hoàn thành",
  },
  "shipmentCertificateForm": {
    "maxDesiredIssueDate": "Ngày phát hành mong muốn không thể sau ngày phát hành tối đa của chứng thư <strong><%= maxDate %></strong>",
    "minDesiredIssueDate": "Ngày phát hành mong muốn không thể sau ngày phát hành tối thiểu của chứng thư <strong><%= minDate %></strong>",
  }
};
